/**
 * Модуль для рендеринга деталей существа
 */

// Helper functions для рендеринга компонентов

/**
 * Рендеринг боевой способности
 */
function renderBattleAbility(ability, escapeHtml, typeNames) {
  if (!ability || typeof ability !== 'object') {
    return '';
  }
  const name = ability.name || ability.title || 'Без названия';
  const damage = ability.damage || ability.attack || 0;
  const effect = ability.effect || ability.description || '';
  const cooldown = ability.cooldown || ability.cooldownTurns || 0;
  const energy = ability.energy || ability.cost || 0;
  const types = Array.isArray(ability.types) ? ability.types : [];
  const escapeFn = escapeHtml || ((str) => String(str || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'));
  return `
    <div class="battle-ability-card" style="padding: 12px; border: 1px solid rgba(59, 130, 246, 0.3); border-radius: 12px; background: rgba(59, 130, 246, 0.05); margin-bottom: 8px;">
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
        <div style="font-weight: 600; font-size: 14px; color: var(--tg-theme-text-color);">${escapeFn(name)}</div>
        ${damage > 0 ? `<div style="font-size: 12px; color: var(--tg-theme-link-color); font-weight: 600;">⚔️ ${damage}</div>` : ''}
      </div>
      ${types.length > 0 ? `<div style="display: flex; gap: 4px; margin-bottom: 8px; flex-wrap: wrap;">
        ${types.map(type => `<span style="background: rgba(59, 130, 246, 0.12); color: var(--tg-theme-link-color); padding: 2px 6px; border-radius: 4px; font-size: 10px; font-weight: 600;">${escapeFn(typeNames[type] || type)}</span>`).join('')}
      </div>` : ''}
      ${effect ? `<div style="font-size: 12px; color: var(--tg-theme-hint-color); line-height: 1.4; margin-bottom: 4px;">${escapeFn(effect)}</div>` : ''}
      <div style="display: flex; gap: 12px; font-size: 11px; color: var(--tg-theme-hint-color);">
        ${cooldown > 0 ? `<span>⏱️ Перезарядка: ${cooldown}</span>` : ''}
        ${energy > 0 ? `<span>⚡ Энергия: ${energy}</span>` : ''}
      </div>
    </div>
  `;
}

/**
 * Рендеринг специальной способности
 */
function renderSpecialAbility(key, abilityData, icon, label, creatureId, level, escapeHtml) {
  if (!abilityData || typeof abilityData !== 'object') {
    abilityData = {};
  }
  const isActive = abilityData.active || abilityData.unlocked || false;
  const levelReq = abilityData.levelRequired || abilityData.level || 0;
  const isUnlocked = level >= levelReq;
  const escapeFn = escapeHtml || ((str) => String(str || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'));
  const description = abilityData.description || abilityData.effect || '';
  return `
    <div class="special-ability-card" style="padding: 12px; border: 1px solid ${isUnlocked ? 'rgba(59, 130, 246, 0.3)' : 'rgba(128, 128, 128, 0.2)'}; border-radius: 12px; background: ${isUnlocked ? 'rgba(59, 130, 246, 0.05)' : 'rgba(128, 128, 128, 0.05)'}; opacity: ${isUnlocked ? '1' : '0.6'};">
      <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 8px;">
        <span style="font-size: 24px;">${icon}</span>
        <div style="flex: 1;">
          <div style="font-weight: 600; font-size: 14px; color: var(--tg-theme-text-color);">${escapeFn(label)}</div>
          ${!isUnlocked ? `<div style="font-size: 11px; color: var(--tg-theme-hint-color);">Требуется уровень ${levelReq}</div>` : ''}
          ${isActive ? `<div style="font-size: 11px; color: var(--tg-theme-link-color);">✓ Активна</div>` : ''}
        </div>
      </div>
      ${description ? `<div style="font-size: 12px; color: var(--tg-theme-hint-color); line-height: 1.4; margin-top: 4px;">${escapeFn(description)}</div>` : ''}
    </div>
  `;
}

/**
 * Рендеринг эмоциональной характеристики
 */
function renderEmotionStat(key, statData, icon, label, bonus1, bonus2, escapeHtml) {
  if (!statData || typeof statData !== 'object') {
    statData = { value: 0, max: 100 };
  }
  const value = statData.value || 0;
  const max = statData.max || 100;
  const percentage = max > 0 ? Math.round((value / max) * 100) : 0;
  const escapeFn = escapeHtml || ((str) => String(str || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'));
  return `
    <div class="emotion-stat-card" style="padding: 12px; border: 1px solid rgba(59, 130, 246, 0.2); border-radius: 12px; background: rgba(59, 130, 246, 0.05);">
      <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 8px;">
        <span style="font-size: 24px;">${icon}</span>
        <div style="flex: 1;">
          <div style="font-weight: 600; font-size: 14px; color: var(--tg-theme-text-color);">${escapeFn(label)}</div>
          <div style="font-size: 12px; color: var(--tg-theme-hint-color);">${value}/${max}</div>
        </div>
      </div>
      <div class="progress-bar" style="height: 6px; background: rgba(59, 130, 246, 0.1); border-radius: 3px; overflow: hidden; margin-bottom: 8px;">
        <div class="progress-fill" style="height: 100%; width: ${percentage}%; background: var(--tg-theme-link-color); transition: width 0.3s;"></div>
      </div>
      <div style="font-size: 11px; color: var(--tg-theme-hint-color); line-height: 1.4;">
        <div>${escapeFn(bonus1 || '')}</div>
        <div>${escapeFn(bonus2 || '')}</div>
      </div>
    </div>
  `;
}

/**
 * Нормализация статистики
 * Экспортируем для использования в других модулях
 */
export function normalizeStats(stats) {
  if (!stats || typeof stats !== 'object') {
    return {};
  }
  // Нормализуем статистику - возвращаем объект с числовыми значениями
  const normalized = {};
  for (const [key, value] of Object.entries(stats)) {
    if (typeof value === 'number') {
      normalized[key] = value;
    } else if (value && typeof value === 'object' && 'value' in value) {
      normalized[key] = value.value || 0;
    } else {
      normalized[key] = Number(value) || 0;
    }
  }
  return normalized;
}

/**
 * Создание HTML из нормализованной статистики
 */
function renderStatsHtml(normalizedStats, hasStats, escapeHtml) {
  if (!hasStats || !normalizedStats || typeof normalizedStats !== 'object') {
    console.warn('[renderStatsHtml] Invalid params:', { hasStats, normalizedStats, type: typeof normalizedStats });
    return '';
  }
  // Проверяем, что есть хотя бы одна статистика (даже если значение 0)
  const hasAnyStats = Object.keys(normalizedStats).length > 0;
  if (!hasAnyStats) {
    console.warn('[renderStatsHtml] No stats keys found:', normalizedStats);
    return '';
  }
  // Создаем HTML для отображения статистики
  const statLabels = {
    attack: 'Атака',
    defense: 'Защита',
    speed: 'Скорость',
    hp: 'Здоровье',
    health: 'Здоровье',
    crit: 'Крит',
    critChance: 'Крит. шанс',
    accuracy: 'Точность',
    energy: 'Энергия',
  };
  const escapeFn = escapeHtml || ((str) => String(str || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'));
  // Определяем порядок отображения статистики
  const statOrder = ['hp', 'attack', 'defense', 'speed', 'critChance', 'energy'];
  const orderedStats = statOrder
    .filter(key => normalizedStats.hasOwnProperty(key))
    .map(key => [key, normalizedStats[key]]);
  
  // Добавляем остальные ключи, которых нет в порядке
  const otherStats = Object.entries(normalizedStats)
    .filter(([key]) => !statOrder.includes(key));
  
  const allStats = [...orderedStats, ...otherStats];
  
  const statsHtml = allStats
    .map(([key, value]) => {
      const label = statLabels[key] || key;
      // Форматируем значение: для critChance показываем как процент
      let displayValue = value;
      if (key === 'critChance' && typeof value === 'number') {
        displayValue = (value * 100).toFixed(1) + '%';
      } else if (typeof value === 'number') {
        displayValue = Math.round(value * 100) / 100; // Округляем до 2 знаков
      } else {
        displayValue = String(value || '');
      }
      const escapedLabel = escapeFn(label);
      const escapedValue = escapeFn(String(displayValue));
      return `<div style="display: flex; justify-content: space-between; margin-bottom: 8px;">
        <span style="color: var(--tg-theme-text-color);">${escapedLabel}:</span>
        <span style="font-weight: 600; color: var(--tg-theme-link-color);">${escapedValue}</span>
      </div>`;
    })
    .join('');
  const result = statsHtml ? `<div style="margin-top: 12px;">${statsHtml}</div>` : '';
  return result;
}

/**
 * Создает функции для работы с деталями существа
 */
export function createCreatureDetailsManager({
  escapeHtml,
  typeNames,
  upgradeMethods,
  formatStatName,
  getProfessionMeta,
  getProfessionIcon,
  getProfessionName,
  safeFetchWithEnhancements,
  apiUrl,
  buildAuthHeaders,
  getTelegramWebAppSafe,
  fetchProfessionsData,
  purchaseCreature,
  showProfessions,
  showUpgrades,
  showUpgradeHistory
}) {
  /**
   * Загрузка данных существа
   */
  async function loadCreatureDetails(creatureIdOrData) {
    const creatureId = creatureIdOrData.creatureId || creatureIdOrData.id;
    try {
      const response = await safeFetchWithEnhancements(
        `${apiUrl}/creatures/${creatureId}/full`,
        { headers: buildAuthHeaders() },
      );
      if (!response.success) {
        const status = response.status || 0;
        const app = getTelegramWebAppSafe();
        if (status === 401 || response.error === "invalid_init_data")
          app &&
            app.showAlert &&
            app.showAlert(
              "🔐 Сессия устарела. Закройте и заново откройте мини-приложение.",
            );
        else if (status === 404)
          app && app.showAlert && app.showAlert("Существо не найдено.");
        else if (app && app.showAlert) {
          const message = response.message || "Ошибка загрузки данных существа",
            htmlWarning =
              (response.payload) != null &&
              response.payload.raw &&
              response.payload.raw.startsWith("<!DOCTYPE")
                ? `

Сервер вернул HTML. Возможно, запрос был отправлен без подписи.`
                : "";
          app.showAlert(message + htmlWarning);
        }
        return;
      }
      const data = response.data;
      if (data != null && data.success && data.creature) {
        try {
          await fetchProfessionsData();
        } catch (error) {
          console.warn(
            "Не удалось обновить список профессий перед показом деталей:",
            (error == null ? void 0 : error.message) || error,
          );
        }
        renderCreatureDetails(data.creature, data.availableUpgradeMethods);
      } else {
        const app = getTelegramWebAppSafe();
        app && app.showAlert && app.showAlert("Ошибка загрузки данных существа");
      }
    } catch (error) {
      console.error("Load creature details error:", error);
      const app = getTelegramWebAppSafe();
      app &&
        app.showAlert &&
        app.showAlert(
          "Ошибка загрузки данных существа: " +
            (error.message || "Неизвестная ошибка"),
        );
    }
  }

  /**
   * Рендеринг деталей существа
   */
  function renderCreatureDetails(creature, availableUpgradeMethods) {
    document
      .querySelectorAll(".screen")
      .forEach((screen) => screen.classList.remove("active"));
    document
      .getElementById("creature-details-screen")
      .classList.add("active");
    
    const contentEl = document.getElementById("creature-details-content"),
      nameEl = document.getElementById("creature-details-name");
    
    nameEl && (nameEl.textContent = creature.creature_name || creature.name || "Детали существа");
    
    const isStoreItem = creature.isStoreItem === true,
      emotionalStats = isStoreItem ? {} : creature.emotional_stats || {},
      profession = isStoreItem ? null : creature.profession || null,
      professionLevel = isStoreItem ? 0 : creature.profession_level || 0,
      professionExp = isStoreItem ? 0 : creature.profession_exp || 0,
      professionMeta = profession ? getProfessionMeta(profession) : null,
      specialAbilities = isStoreItem ? {} : creature.special_abilities || {},
      activeUpgrades = isStoreItem ? [] : creature.activeUpgrades || [],
      baseAttributes = creature.base_attributes || creature.baseAttributes || {},
      creatureTypes = Array.isArray(baseAttributes.types) ? baseAttributes.types : [],
      creatureAbilities = Array.isArray(baseAttributes.abilities) ? baseAttributes.abilities : [],
      ultimate = baseAttributes.ultimate || null,
      description = baseAttributes.description || "",
      baseStats =
        baseAttributes.baseStats ||
        baseAttributes.stats ||
        baseAttributes.base_stats ||
        creature.baseStats ||
        creature.stats ||
        null,
      normalizedStats = normalizeStats(baseStats),
      hasStats = baseStats && typeof baseStats === 'object' && Object.keys(baseStats).length > 0,
      statsHtml = renderStatsHtml(normalizedStats, hasStats) || 
        (hasStats ? '' : '<div style="font-size:13px;color:var(--tg-theme-hint-color);margin-bottom:12px;">Статистика не определена</div>'),
      priceStars = creature.price_stars ?? creature.priceStars ?? 0;
    
    // Применяем активные улучшения к эмоциональным характеристикам
    if (!isStoreItem) {
      activeUpgrades.forEach((upgrade) => {
        if (upgrade.statName === "all") {
          Object.keys(emotionalStats).forEach((key) => {
            if (emotionalStats[key] &&
                typeof emotionalStats[key] == "object") {
              emotionalStats[key].tempBonus = (emotionalStats[key].tempBonus || 0) + upgrade.effectAmount;
              emotionalStats[key].tempBonusDuration = upgrade.remainingSeconds;
            }
          });
        } else if (emotionalStats[upgrade.statName]) {
          emotionalStats[upgrade.statName].tempBonus =
            (emotionalStats[upgrade.statName].tempBonus || 0) + upgrade.effectAmount;
          emotionalStats[upgrade.statName].tempBonusDuration = upgrade.remainingSeconds;
        }
      });
    }
    
    const imageUrl = escapeHtml(creature.creature_image || creature.imageUrl || "/creatures/1.png"),
      priceHtml = isStoreItem
        ? `<div style="color: var(--tg-theme-link-color); font-size: 14px; display: flex; gap: 6px; align-items: center; justify-content: center; margin-top: 8px;">
                        <span>Цена:</span>
                        <span style="font-weight:700;">${priceStars} ⭐</span>
                   </div>`
        : `<div style="color: var(--tg-theme-hint-color); font-size: 14px;">
                        Уровень ${creature.level || 1} | Опыт: ${creature.exp || 0}/100
                   </div>`,
      storeItemNote = isStoreItem
        ? '<div style="font-size:12px;color:var(--tg-theme-hint-color);margin-top:6px;">Этот Глитчлинг ещё не в вашей коллекции.</div>'
        : "";
    
    let html = `
                <div style="text-align: center; margin-bottom: 20px;">
                    <img src="${imageUrl}" style="width: 150px; height: 150px; object-fit: cover; border-radius: 16px;" onerror="this.src='/creatures/1.png';">
                    <div style="margin-top: 12px;">
                        <div style="font-weight: 600; font-size: 18px;">${creature.creature_name || creature.name}</div>
                        ${priceHtml}
                        ${storeItemNote}
                        ${
                          !isStoreItem && creature.energy !== void 0
                            ? `
                        <div style="color: var(--tg-theme-link-color); font-size: 14px; margin-top: 4px;">
                            ⚡ Энергия: ${creature.energy}/100
                            ${
                              creature.energyRecovery &&
                              creature.energyRecovery.nextRecoveryIn &&
                              creature.energy < 100
                                ? `
                            <span style="font-size: 11px; color: var(--tg-theme-hint-color);">
                                (восстановление через ${Math.ceil(creature.energyRecovery.nextRecoveryIn / 60)} мин)
                            </span>
                            `
                                : ""
                            }
                        </div>
                        `
                            : ""
                        }
                        ${
                          isStoreItem
                            ? `
                        <div style="margin-top: 16px;">
                            <button class="btn btn-primary" id="creature-details-buy-btn" style="width: 100%;">Купить за ${priceStars} ⭐</button>
                        </div>
                        `
                            : ""
                        }
                    </div>
                </div>
            `;
    
    // Активные улучшения
    if (activeUpgrades.length > 0) {
      html += `
                    <div class="info-card" style="margin-bottom: 16px;">
                        <h4>✨ Активные улучшения</h4>
                        <div style="margin-top: 8px;">
                            ${activeUpgrades
                              .map((upgrade) => {
                                let upgradeName = upgrade.upgradeMethod;
                                try {
                                  const method = upgradeMethods[upgrade.upgradeMethod];
                                  if (method) upgradeName = method.name;
                                } catch {}
                                const hours = Math.floor(upgrade.remainingSeconds / 3600),
                                  minutes = Math.floor((upgrade.remainingSeconds % 3600) / 60),
                                  timeStr = hours > 0 ? `${hours}ч ${minutes}м` : `${minutes}м`;
                                return `
                                    <div style="font-weight: 600;">${upgradeName}</div>
                                    <div style="color: var(--tg-theme-hint-color); font-size: 11px;">
                                        +${upgrade.effectAmount} к ${formatStatName(upgrade.statName)} • Осталось: ${timeStr}
                                    </div>
                                `;
                              })
                              .join("")}
                        </div>
                    </div>
                `;
    }
    
    // Профессия
    let professionHtml = "";
    if (profession && professionMeta) {
      const progressPercent = Math.min(100, Math.round((professionExp / 100) * 100)),
        benefitsHtml =
          Array.isArray(professionMeta.benefits) && professionMeta.benefits.length > 0
            ? `<ul class="profession-bonus-list">${professionMeta.benefits.map((benefit) => `<li>${escapeHtml(benefit)}</li>`).join("")}</ul>`
            : "";
      professionHtml = `
                    <div style="margin-top: 8px;">
                        <div style="display: flex; align-items: center; gap: 12px;">
                            <span style="font-size: 28px;">${professionMeta.icon || getProfessionIcon(profession)}</span>
                            <div>
                                <div style="font-weight: 600; font-size: 16px;">${escapeHtml(professionMeta.name || getProfessionName(profession))}</div>
                                <div style="font-size: 12px; color: var(--tg-theme-hint-color);">
                                    Уровень ${professionLevel}
                                </div>
                            </div>
                        </div>
                        <div class="profession-progress">
                            <div style="font-size: 11px; color: var(--tg-theme-hint-color); margin-bottom: 4px;">
                                Опыт: ${professionExp}/100 до следующего уровня
                            </div>
                            <div class="progress-bar">
                                <div class="progress-fill" style="width: ${progressPercent}%;"></div>
                            </div>
                        </div>
                        ${benefitsHtml}
                    </div>
                `;
    }
    
    // Профессия секция
    // Профессию можно выбирать только для существ из коллекции игрока, а не из магазина
    if (!isStoreItem) {
      html += `
                    <div class="info-card" style="margin-bottom: 16px;">
                        <h4>💼 Профессия</h4>
                        ${
                          profession && professionHtml
                            ? professionHtml
                            : `
                        <div style="margin-top: 8px;">
                            <button class="btn btn-secondary" onclick="showProfessions(${creature.creature_id})" style="width: 100%;">
                                Выбрать профессию
                            </button>
                        </div>
                        `
                        }
                    </div>
                `;
    }
    
    // Боевой профиль
    if ((statsHtml && statsHtml.trim().length > 0) || creatureTypes.length > 0 || description || creatureAbilities.length > 0 || ultimate) {
      const typesHtml =
          creatureTypes.length > 0
            ? `<div style="display:flex;flex-wrap:wrap;gap:6px;margin-bottom:12px;">
                            ${creatureTypes.map((type) => `<span style="background:rgba(59,130,246,0.12);color:var(--tg-theme-link-color);padding:4px 10px;border-radius:999px;font-size:12px;font-weight:600;">${escapeHtml(typeNames[type] || type)}</span>`).join("")}
                       </div>`
            : "",
        descriptionHtml = description
          ? `<p style="font-size:13px;line-height:1.5;color:var(--tg-theme-hint-color);margin-bottom:12px;">${escapeHtml(description).replace(/\n/g, "<br>")}</p>`
          : "",
        abilitiesHtml =
          creatureAbilities.length > 0
            ? `<div style="display:flex;flex-direction:column;gap:10px;">
                            ${creatureAbilities.map(ability => renderBattleAbility(ability, escapeHtml, typeNames)).join("")}
                       </div>`
            : '<div style="font-size:13px;color:var(--tg-theme-hint-color);">Боевые способности ещё не определены.</div>',
        ultimateHtml = ultimate
          ? `<div style="margin-top:16px;padding:12px;border:1px dashed rgba(59,130,246,0.35);border-radius:12px;background:rgba(59,130,246,0.06);">
                            <div style="font-weight:700;font-size:14px;color:var(--tg-theme-link-color);">🌀 Ультимативная способность</div>
                            <div style="font-size:13px;margin-top:4px;">${escapeHtml(ultimate.name || "Ультимейт")}</div>
                            <div style="font-size:12px;color:var(--tg-theme-hint-color);margin-top:4px;">${escapeHtml(ultimate.effect || "").replace(/\n/g, "<br>")}</div>
                       </div>`
          : "";
      html += `
                    <div class="info-card" style="margin-bottom: 16px;">
                        <h4>⚔️ Боевой профиль</h4>
                        ${statsHtml || '<div style="font-size:13px;color:var(--tg-theme-hint-color);margin-bottom:12px;">Статистика не определена</div>'}
                        ${typesHtml || ''}
                        ${descriptionHtml || ''}
                        ${abilitiesHtml || ''}
                        ${ultimateHtml || ''}
                    </div>
                `;
    }
    
    // Эмоции
    if (!isStoreItem) {
      html += `
                    <div class="info-card" style="margin-bottom: 16px;">
                        <h4>😊 Эмоции</h4>
                        <div class="stats-grid">
                            ${renderEmotionStat("happiness", emotionalStats.happiness || { value: 50, max: 100 }, "😊", "Счастье", "+ к эффективности", "+ к социализации", escapeHtml)}
                            ${renderEmotionStat("curiosity", emotionalStats.curiosity || { value: 30, max: 100 }, "🔍", "Любопытство", "+ к находкам", "+ к обучению", escapeHtml)}
                            ${renderEmotionStat("confidence", emotionalStats.confidence || { value: 20, max: 100 }, "💪", "Уверенность", "+ к защите", "+ к лидерству", escapeHtml)}
                            ${renderEmotionStat("sociability", emotionalStats.sociability || { value: 40, max: 100 }, "💬", "Общительность", "+ к торговле", "+ к команде", escapeHtml)}
                            ${renderEmotionStat("empathy", emotionalStats.empathy || { value: 60, max: 100 }, "🤗", "Эмпатия", "+ к помощи", "+ к дружбе", escapeHtml)}
                        </div>
                        <div style="margin-top: 16px; display: flex; gap: 8px;">
                            <button class="btn btn-secondary" onclick="showUpgrades(${creature.creature_id})" style="flex: 1;">💪 Улучшить характеристики</button>
                            <button class="btn btn-secondary" onclick="showUpgradeHistory(${creature.creature_id})" style="flex: 1;">📜 История улучшений</button>
                        </div>
                    </div>
                `;
    }
    
    // Способности
    if (!isStoreItem) {
      html += `
                    <div class="info-card" style="margin-bottom: 16px;">
                        <h4>⭐ Способности</h4>
                        <div class="stats-grid">
                            ${renderSpecialAbility("collector", specialAbilities.collector || {}, "🧩", "Фрагментатор", creature.creature_id, creature.level, escapeHtml)}
                            ${renderSpecialAbility("trader", specialAbilities.trader || {}, "🎛️", "Аудио-демон", creature.creature_id, creature.level, escapeHtml)}
                            ${renderSpecialAbility("influencer", specialAbilities.influencer || {}, "🖼️", "Искажатель изображения", creature.creature_id, creature.level, escapeHtml)}
                            ${renderSpecialAbility("breeder", specialAbilities.breeder || {}, "🕳️", "Пустотный протокол", creature.creature_id, creature.level, escapeHtml)}
                        </div>
                    </div>
                `;
    }
    
    contentEl.innerHTML = html;
    
    // Обработчик покупки для товаров из магазина
    if (isStoreItem) {
      const buyBtn = document.getElementById("creature-details-buy-btn");
      if (buyBtn && purchaseCreature) {
        buyBtn.onclick = () => purchaseCreature(creature);
      }
    }
  }

  return {
    loadCreatureDetails,
    renderCreatureDetails
  };
}

